var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoHayday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-hayday_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 179.6 51.6",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo-hayday_svg__st2{fill:#5f9dd0}.logo-hayday_svg__st3{fill:#f7c315}.logo-hayday_svg__st5{fill:#f4a41d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9 36.2h-.2c-2.2 3.4-4.9 4.9-9 4.9-7.5 0-14.3-6.2-14.3-16.4S38.9 8.3 46.7 8.3c3.8 0 6.8 1.4 8.8 4.3h.2V9.2h10.4v31.1H55.9v-4.1zm-.2-11.5c0-4.3-2.7-7-6.4-7-3.8 0-6.5 2.7-6.5 7 0 4.1 2.7 7.1 6.5 7.1 3.7 0 6.4-3 6.4-7.1z",
    fill: "#97c8ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4 37.3L60.6 9.2h10.9l6.7 16.4L84 9.2h10.5L78 51.6H67.5l5.9-14.3z",
    fill: "#77b9e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logo-hayday_svg__st2",
    d: "M0 0h11v15.5h14.3V0h11v40.3h-11V24.9H11v15.5H0V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logo-hayday_svg__st3",
    d: "M141 36.2h-.2c-2.2 3.4-4.9 4.9-9 4.9-7.5 0-14.3-6.2-14.3-16.4S124 8.3 131.8 8.3c3.8 0 6.8 1.4 8.8 4.3h.2V9.2h10.4v31.1H141v-4.1zm-.2-11.5c0-4.3-2.7-7-6.4-7-3.8 0-6.5 2.7-6.5 7 0 4.1 2.7 7.1 6.5 7.1 3.7 0 6.4-3 6.4-7.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "logo-hayday_svg__st3",
    d: "M158.5 37.3L145.7 9.2h10.9l6.7 16.4 5.9-16.4h10.5l-16.5 42.4h-10.5l5.8-14.3zM111.4 36.2h-.2c-1.8 3.1-4.8 4.9-8.9 4.9-7.6 0-14.4-6.2-14.4-16.4s6.5-16.4 14.3-16.4c3.9 0 7 1.5 8.9 4.1h.2V0h10.4v40.3h-10.2v-4.1zm-.2-11.5c0-4.3-2.7-7-6.4-7-3.8 0-6.5 2.7-6.5 7 0 4.1 2.7 7.1 6.5 7.1 3.6 0 6.4-3 6.4-7.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 36.3V12.9c-2.5 2.8-4 6.8-4 11.8 0 4.9 1.6 8.8 4 11.6z",
    fill: "#2585c3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "logo-hayday_svg__st2",
    d: "M66.1 21.3V9.2h-5.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "logo-hayday_svg__st5",
    d: "M121.8 36.5V12.8c-2.6 2.8-4.1 6.9-4.1 11.9-.1 5 1.5 9 4.1 11.8zM151.2 21.3V9.2h-5.5z"
  })));
}

export default SvgLogoHayday;